<template>
  <el-table
        stripe
    size="mini"
    :data="tableData"
    height="0"
    class="flex-grow-1"
    :class="{'dark':skinType}"
    :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
  >
    <el-table-column  type="index" width="50" label="#" align="center">
    </el-table-column>
    <el-table-column prop="NickName"  label="名称" min-width="120" align="center">
    </el-table-column>
    <el-table-column prop="electricityA"  label="Ia(A)" align="center">
    </el-table-column>
    <el-table-column prop="electricityB"  label="Ib(A)" align="center">
    </el-table-column>
    <el-table-column prop="electricityC"  label="Ic(A)" align="center">
    </el-table-column>
     <el-table-column prop="electricityAver"  label="⊿I(%)" align="center">
       <template slot-scope="scope">
         {{scope.row.electricityAver=='NaN'?'0.00':scope.row.electricityAver}}
       </template>
    </el-table-column>
    <el-table-column prop="voltageA"  label="Ua(V)" align="center">
    </el-table-column>
    <el-table-column prop="voltageB"  label="Ub(V)" align="center">
    </el-table-column>
    <el-table-column prop="voltageC"  label="Uc(V)" align="center">
    </el-table-column>
     <el-table-column prop="voltageAver"  label="⊿U(%)" align="center">
       <template slot-scope="scope">
         {{scope.row.voltageAver=='NaN'?'0.00':scope.row.voltageAver}}
       </template>
    </el-table-column>
  </el-table>
</template>

<script>
import TurnAskingMixin from '@/mixins/turn-ask';
import { getsanxiangbupingheng } from '../../../api/statistical-analysis/statisticalanalysis';

export default {
  mixins: [TurnAskingMixin],
  data() {
    return {
      tableData: [],
      timeOut: null,
    };
  },
  props: {
    select: String,
  },
  watch: {
    select() {
      this.requestOpenCapacity();
    },
  },
  created() {
    this.requestOpenCapacity();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    // 请求可开放容量
    requestOpenCapacity() {
      if (!this.select) {
        this.tableData = [];
        return;
      }
      clearTimeout(this.timeOut);
      getsanxiangbupingheng({
        EquipmentIdStr: this.select,
      }).then((res) => {
        this.tableData = res;
      }).catch(() => {
        this.tableData = [];
      }).then(() => {
        this.timeOut = this.turnAsking({
          routeName: this.routeName,
          nowRouteName: this.$route.name,
          func: this.requestOpenCapacity,
        }, 5 * 1000);
      });
    },
  },
};
</script>
<style scoped>
table {
  background: #898a8a;
}
</style>
